import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import BankForm from '@/components/payoutAccounts/BankForm.vue';
import DeleteConfirmation from '@/components/payoutAccounts/DeleteConfirmation.vue';
import ManagePayouts from '@/components/payoutAccounts/ManagePayouts.vue';
import MomoForm from '@/components/payoutAccounts/MomoForm.vue';
import SelectPayout from '@/components/payoutAccounts/SelectPayout.vue';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import router, { RoutePaths } from '@/router';
import { PayoutAccountsTypes } from '@/types/payout-accounts';
import useTransactionsStore from '@/store/modules/transactions';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
export default defineComponent({
    name: 'PayoutAccounts',
    components: {
        BankForm,
        DeleteConfirmation,
        ManagePayouts,
        MomoForm,
        SelectPayout,
        TransactHeader,
        LoaderComponent,
    },
    setup() {
        const payoutAccountsStore = usePayoutAccountsStore();
        const { currentStep, currentStepIndex, getStepsProps, fromTransaction, payoutAccounts, selectedPayoutMethod, } = storeToRefs(payoutAccountsStore);
        const transactionsStore = useTransactionsStore();
        const { loading } = storeToRefs(transactionsStore);
        const goBack = () => {
            if (fromTransaction.value) {
                switch (currentStep.value) {
                    case PayoutAccountsTypes.PayoutComponents.ManagePayouts: {
                        payoutAccountsStore.resetActivePayoutAccount();
                        return router.push(RoutePaths.Transact);
                    }
                    case PayoutAccountsTypes.PayoutComponents.FormSelect: {
                        const accounts = payoutAccounts.value.filter(acct => acct.accountType === selectedPayoutMethod.value);
                        if (accounts.length) {
                            return (currentStep.value =
                                PayoutAccountsTypes.PayoutComponents.ManagePayouts);
                        }
                        payoutAccountsStore.resetActivePayoutAccount();
                        return router.push(RoutePaths.Transact);
                    }
                    default:
                }
                return undefined;
            }
            if (currentStepIndex.value < 1) {
                payoutAccountsStore.resetStep();
                return router.push(RoutePaths.Home);
            }
            return payoutAccountsStore.setStepIndex(currentStepIndex.value - 1);
        };
        return {
            currentStepIndex,
            currentStep,
            goBack,
            getStepsProps,
            loading,
        };
    },
});
